import {connect} from "react-redux"
import State from "../../../../models/State"

export const mapStateToProps = (state: State) => {
    const {template} = state

    return {
        templating: template,
    }
}

export default connect(mapStateToProps)
